export default "__VITE_ASSET__137ca502__"